import React from "react";

import { Trans, withTranslation } from "react-i18next";
import i18next from "i18next";
import { RadioGroup, Radio, Button, H2, H5, Callout } from "@blueprintjs/core";

import { DateRangePicker3, TimePrecision } from "@blueprintjs/datetime2";
import ReactToPrint from "react-to-print";

import Periods from "../../Structure/periods";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";

import Title from "../../Structure/logo";
import KeyValues from "./KeyValues";
import ParkingTimeStat from "./ParkingTimeStat";
import ParkingOccupancy from "./ParkingOccupancy";
import {
  UserTypeRepartitionEntry,
  UserTypeRepartitionExit,
} from "./UserTypeRepartition";
import ResaRepartition from "./ResaRepartition";
import DeviceMostUsed from "./DeviceMostUsed";
import { EquipmentSelect } from "../../Structure/EquipmentSelector";
import { MultiParkSelect } from "../../Structure/ParkSelector";
import ExportActivityReport from "../Export/ExportActivityReport";
import ALPRPerformances from "./ALPRPerformances";
import ParkSaturations from "./Saturations";
import ParkingIncome from "./ParkingIncome";

class ActivityReport extends React.Component {
  constructor() {
    super();

    var d = new Date();
    var dd = new Date();
    d.setMonth(d.getMonth() - 1);
    d.setHours(0, 0, 0, 0);
    dd.setHours(23, 59, 0, 0);
    var today = [d, dd];

    this.state = {
      configFromSrv: [],
      btnLoading: false,
      filter: "all",
      filterValue: "all",
      granularityId: 0,
      selectedRange: today,
      selectedRangeQueryReady: [today[0].toISOString(), today[1].toISOString()],
      filterValueParks: [],
    };
    this.generateReport = this.generateReport.bind(this);
  }

  componentDidMount() {
    this.setState({ btnLoading: true });
    authenticatedGetFetch(
      "/customactivity",
      (res) => {
        this.setState({ configFromSrv: res, btnLoading: false });
      },
      undefined,
      undefined,
      () => {
        this.setState({ configFromSrv: [], btnLoading: false });
      }
    );
  }

  generateReport() {
    this.setState({ btnLoading: true });

    let parkPk = undefined;
    let eq = undefined;

    if (this.state.filter === "park") {
      parkPk = this.state.parkPk === undefined ? 0 : this.state.parkPk;
    } else if (this.state.filter === "equipment")
      eq = this.state.filterValue === undefined ? 0 : this.state.filterValue;

    const urlparams = JSON.parse(
      JSON.stringify({
        fr: this.state.selectedRangeQueryReady[0],
        to: this.state.selectedRangeQueryReady[1],
        parkpk: parkPk,
        equipment: eq,
        lg: i18next.language.split("-")[0].toLowerCase(),
        parks: this.state.filterValueParks,
      })
    );

    const params = new URLSearchParams(
      JSON.parse(
        JSON.stringify({
          fr: this.state.selectedRangeQueryReady[0],
          to: this.state.selectedRangeQueryReady[1],
          //park: p,
          parkpk: parkPk,
          equipment: eq,
          lg: i18next.language.split("-")[0].toLowerCase(),
        })
      )
    );
    for (const parkpk of this.state.filterValueParks)
      params.append("parks", parkpk);

    this.setState({ urlsearchparams: params });

    this.setState({
      filterSelection: urlparams,
      btnLoading: false,
      fr: this.state.selectedRangeQueryReady[0],
      to: this.state.selectedRangeQueryReady[1],
    });
  }

  handleDateChange = (dateRange) => {
    if (dateRange[0]) {
      dateRange[0].setSeconds(0);
      dateRange[0].setMilliseconds(0);
    }
    if (dateRange[1]) {
      dateRange[1].setSeconds(59);
      dateRange[1].setMilliseconds(999);
    }
    this.setState({ selectedRange: dateRange }, () => {
      if (
        dateRange[0] !== undefined &&
        dateRange[1] !== undefined &&
        dateRange[0] !== null &&
        dateRange[1] !== null
      )
        this.setState({
          selectedRangeQueryReady: [
            dateRange[0].toISOString(),
            dateRange[1].toISOString(),
          ],
        });
    });
  };

  getWidgets() {
    const UserFavs = [];
    let i = 0;
    for (const w of this.state.configFromSrv) {
      //DO NOT FORGET TO APPLY CHANGE TO BACK for Activity/export route API
      switch (w) {
        case 0:
          UserFavs.push(
            <KeyValues
              key={"ec" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 1:
          UserFavs.push(
            <ParkingTimeStat
              key={"pts" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 2:
          UserFavs.push(
            <ParkingOccupancy
              key={"po" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 3:
          UserFavs.push(
            <UserTypeRepartitionEntry
              key={"utrex" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 4:
          UserFavs.push(
            <UserTypeRepartitionExit
              key={"utren" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 5:
          UserFavs.push(
            <DeviceMostUsed
              key={"dmu" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 6:
          UserFavs.push(
            <ALPRPerformances
              key={"alpr" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 7:
          UserFavs.push(
            <ResaRepartition
              key={"resa" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 8:
          UserFavs.push(
            <ParkSaturations
              key={"satur" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        case 9:
          UserFavs.push(
            <ParkingIncome
              key={"income" + JSON.stringify(this.state.filterSelection)}
              urlsearchparams={this.state.urlsearchparams}
            />
          );
          break;

        default:
          break;
      }
      UserFavs.push(<br key={"section" + i++}/>);
    }
    return UserFavs;
  }

  render() {
    return (
      <div>
        <div className="component-body">
          <Title icon="timeline-line-chart" text="activity report" />
          <div className="flexbox-center">
            <DateRangePicker3
              locale={i18next.language}
              shortcuts={[
                { dateRange: Periods.today, label: <Trans>today</Trans> },
                {
                  dateRange: Periods.yesterday,
                  label: <Trans>yesterday</Trans>,
                },
                {
                  dateRange: Periods.lastWeek,
                  label: <Trans>last week</Trans>,
                },
                {
                  dateRange: Periods.currentMonth,
                  label: <Trans>current month</Trans>,
                },
                {
                  dateRange: Periods.lastMonth,
                  label: <Trans>past month</Trans>,
                },
                {
                  dateRange: Periods.lastThreeMonth,
                  label: <Trans>past 3 months</Trans>,
                },
                {
                  dateRange: Periods.lastSixMonth,
                  label: <Trans>past 6 months</Trans>,
                },
                {
                  dateRange: Periods.lastYear,
                  label: <Trans>past year</Trans>,
                },
                {
                  dateRange: Periods.lastTwoYear,
                  label: <Trans>past 2 years</Trans>,
                },
              ]}
              allowSingleDayRange={true}
              contiguousCalendarMonths={false}
              timePrecision={TimePrecision.MINUTE}
              value={this.state.selectedRange}
              onChange={this.handleDateChange}
            />
            <div>
              <RadioGroup
                label={<Trans>display the activity report for</Trans>}
                onChange={(selection) =>
                  this.setState({
                    filter: selection.target.value,
                    filterValue: undefined,
                    filterValueParks: [],
                  })
                }
                selectedValue={this.state.filter}
              >
                <Radio label={<Trans>all</Trans>} value="all" />
                <Radio label={<Trans>some parks</Trans>} value="park" />
                <Radio label={<Trans>an equipment</Trans>} value="equipment" />
              </RadioGroup>
              {this.state.filter === "park" ? (
                <MultiParkSelect
                  onSelect={(parks) => {
                    this.setState({ filterValueParks: parks });
                  }}
                />
              ) : null}
              {this.state.filter === "equipment" ? (
                <EquipmentSelect
                  onSelect={(id) => this.setState({ filterValue: id })}
                />
              ) : null}

              <Button
                rightIcon="arrow-right"
                intent="success"
                text={<Trans>generate report</Trans>}
                onClick={this.generateReport}
                loading={this.state.btnLoading}
              />
            </div>
          </div>
          <div
            ref={(el) => (this.componentRef = el)}
            className={this.state.printing ? "printContent" : ""}
          >
            {this.state.fr !== undefined ? (
              <Callout intent="primary">
                <H2 className="space-title">
                  <Trans>activity report</Trans>
                </H2>
                <H5>
                  <Trans>from</Trans>{" "}
                  {new Date(this.state.fr).toLocaleDateString(i18next.language)}{" "}
                  <Trans>to</Trans>{" "}
                  {new Date(this.state.to).toLocaleDateString(i18next.language)}
                </H5>
                {/* TODO {this.state.filter === "park" && <H5><Trans>on park n°</Trans> {this.state.filterValue}</H5>} */}
                {this.state.filter === "equipment" && (
                  <H5>
                    <Trans>on device n°</Trans> {this.state.filterValue}
                  </H5>
                )}
              </Callout>
            ) : null}
            <br/>
            <Callout
              intent="warning"
              hidden={this.state.urlsearchparams !== undefined}
            >
              <Trans>please generate a report to visualize data</Trans>
            </Callout>
            {this.getWidgets()}
          </div>
        </div>
        {this.state.fr !== undefined && !this.state.btnLoading ? (
          <div className="flexbox-left">
            <ExportActivityReport
              urlsearchparams={this.state.urlsearchparams}
              fr={this.state.fr}
              to={this.state.to}
            />
            <ReactToPrint
              trigger={() => {
                return <Button icon="print" />;
              }}
              onBeforeGetContent={() => {
                this.setState({ printing: true });
              }}
              onAfterPrint={() => {
                this.setState({ printing: false });
              }}
              pageStyle={`
                .MuiTableCell-root.MuiTableCell-body.MuiTableCell-alignLeft,
                .MuiButtonBase-root.MuiTableSortLabel-root {
                  font-size: 9pt !important;
                }
                .MuiTableCell-root {border: 1px solid black !important;}`}
              documentTitle={
                "ActivityReport-" +
                new Date(this.state.fr).toLocaleDateString("fr", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }) +
                "-" +
                new Date(this.state.to).toLocaleDateString("fr", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
              }
              content={() => this.componentRef}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withTranslation()(ActivityReport);
